import { useState } from 'react';
import { Info, ChevronDown, ChevronUp } from 'lucide-react';

interface AdminPageHeaderProps {
  title: string;
  /** One sentence explaining what this page is for, visible to all admin users */
  objective: string;
  icon?: string;
}

/**
 * Standard header for every admin page.
 * Renders title + collapsible objective note so non-technical users
 * always know what the page is about.
 */
export function AdminPageHeader({ title, objective, icon }: AdminPageHeaderProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <h1
        className="font-display"
        style={{ fontSize: '1.5rem', color: 'var(--text-primary)', margin: '0 0 0.625rem' }}
      >
        {icon && <span style={{ marginRight: '0.4rem' }}>{icon}</span>}
        {title}
      </h1>

      <div
        style={{
          padding: '0.6rem 0.875rem',
          backgroundColor: 'rgba(31,78,95,0.06)',
          border: '1px solid rgba(31,78,95,0.15)',
          borderRadius: 'var(--radius-sm)',
          fontSize: 'var(--text-caption)',
          color: 'var(--text-secondary)',
          lineHeight: 1.55,
          display: 'flex',
          alignItems: 'flex-start',
          gap: '0.5rem',
        }}
      >
        <Info size={13} style={{ color: 'var(--petrol)', flexShrink: 0, marginTop: '1px' }} />
        {!collapsed && <span style={{ flex: 1 }}>{objective}</span>}
        {collapsed && (
          <span style={{ flex: 1, color: 'var(--text-muted)', fontStyle: 'italic' }}>
            Objetivo da página (clique para expandir)
          </span>
        )}
        <button
          onClick={() => setCollapsed(v => !v)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: 'var(--text-muted)', display: 'flex', alignItems: 'center' }}
          title={collapsed ? 'Expandir' : 'Recolher'}
        >
          {collapsed ? <ChevronDown size={13} /> : <ChevronUp size={13} />}
        </button>
      </div>
    </div>
  );
}
